import { useMemo } from "react";
import { format } from "date-fns";
import { apiGet } from "../utils/apiClient";

/**
 * Retrieves SpecialsBusBlocksByNumber data.
 * @returns - A promise that resolves to the SpecialsBusBlocksByNumber data.
 */
export const useFetchSpecialsBusBlocksByNumber = () => {
  const memoizedFetchSpecialsBusBlocksByNumber = useMemo(
    () => async (boxJumpToVal, assignmentDate, rowFilter, pulloutDivision) => {
      const apiDate = format(assignmentDate, "dd-MMM-yyyy");
      return apiGet(
        `/SpecialsBusBlocksByBlockNumber/${apiDate}/${rowFilter}/${pulloutDivision}/${boxJumpToVal}`,
        "fetching Specials Bus Blocks By Number"
      );
    },
    []
  );

  return memoizedFetchSpecialsBusBlocksByNumber;
};
